import { combineReducers } from 'redux';

import { Customer } from '../../../../types/items';
import {
  getCustomerFail,
  getCustomerRequest,
  getCustomerSuccess,
  saveCustomerFail,
  saveCustomerRequest,
  saveCustomerSuccess,
  initCustomerRequest,
  initCustomerSuccess,
  initCustomerFail,
  createCustomerRequest,
  createCustomerSuccess,
  createCustomerFail,
  resetCurrentCustomer,
} from '../actions';
import { CustomerAction } from '../types';
import { Loadable, Reducer } from '../../../types';

type State = Loadable<Customer>;
type ReducerOf<T extends keyof State> = Reducer<State, CustomerAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getCustomerRequest.type:
    case initCustomerRequest.type:
    case resetCurrentCustomer.type:
      return null;
    case saveCustomerSuccess.type:
    case getCustomerSuccess.type:
    case initCustomerSuccess.type:
    case createCustomerSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getCustomerRequest.type:
    case saveCustomerRequest.type:
    case initCustomerRequest.type:
    case createCustomerRequest.type:
      return true;

    case getCustomerSuccess.type:
    case getCustomerFail.type:
    case saveCustomerSuccess.type:
    case saveCustomerFail.type:
    case initCustomerSuccess.type:
    case initCustomerFail.type:
    case createCustomerSuccess.type:
    case createCustomerFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
});
